<!--School Select-->
<div class="groups-MenuBarItem groups-3ItemFlex">
	<label class="groups-InnerItem control-label">School</label>
	<div>
		<!-- <select [disabled]="LoadingSchool == true || LoadingEvent == true || LoadingSchedule == true" class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="SchoolID">
            <option value="" style="display:none;"></option>
            <option *ngFor="let o of schoolList" [ngValue]="o.SchoolID">[{{o.SchoolNumber}}] - {{o.SchoolName}}</option>
        </select> -->

		<caass-schoolselector [ShowAll]="false" [Disabled]="LoadingEvent == true || LoadingSchedule == true"> </caass-schoolselector>
	</div>
</div>

<p-fullCalendar #ScheduledEvents [events]="lstFormatted" [options]="options"></p-fullCalendar>
